import { Action, createReducer, on } from '@ngrx/store';
import { IBusinessPaymentRunDetailEmployees } from '../dto/business-payment-run-detail-employees.dto';
import * as actions from '../actions';

export const businessPaymentRunDetailEmployeesByProductFeatureKey = 'businessPaymentRunDetailEmployeesByProduct';

export interface BusinessPaymentRunDetailEmployeesByProductState {
  loadBusinessPaymentRunDetailEmployeesByProduct: any;
  loadBusinessPaymentRunDetailEmployeesByProductSuccess: IBusinessPaymentRunDetailEmployees[];
}

export const initialState: BusinessPaymentRunDetailEmployeesByProductState = {
  loadBusinessPaymentRunDetailEmployeesByProduct: undefined,
  loadBusinessPaymentRunDetailEmployeesByProductSuccess: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadBusinessPaymentRunDetailEmployeesByProduct, (state, action) => ({
    ...state,
    loadBusinessPaymentRunDetailEmployeesByProduct: action.request
  })),
  on(actions.loadBusinessPaymentRunDetailEmployeesByProductSuccess, (state, action) => ({
    ...state,
    loadBusinessPaymentRunDetailEmployeesByProductSuccess: action.response
  }))
);

export const getBusinessPaymentRunDetailEmployeesByProduct = (state: BusinessPaymentRunDetailEmployeesByProductState) =>
  state.loadBusinessPaymentRunDetailEmployeesByProductSuccess;
